import { truncate } from 'lodash';
import sanitizeHtml from 'sanitize-html';

const truncateSmsBody = (body: string) => {
    return truncate(
        sanitizeHtml(body, {
            allowedTags: [],
            allowedAttributes: {},
        }),
        {
            length: 80,
        },
    );
};

export { truncateSmsBody };
